module.exports = __webpack_public_path__ + "static/part-5-b92f84fe9702a35b12f10af4588ba4c2.svg";